export function circleToPolygon(center: google.maps.LatLng, radius: number): google.maps.Polygon {

  const numPoints = 60; // Número de puntos para aproximar el círculo
  const angleStep = (2 * Math.PI) / numPoints;
  const coordinates: Array<google.maps.LatLng> = [];

  for (let i = 0; i < numPoints; i++) {
    const angle = i * angleStep;
    const point = google.maps.geometry.spherical.computeOffset(center, radius, angle * (180 / Math.PI));
    coordinates.push(point);
  }

  return new google.maps.Polygon({
    paths: coordinates
  });

}
